( function( $ ) {
    $( document ).on( 'change', '[data-filter-menu-sort-select]', function ( e ) {
        if ( !$( '[data-filter-target]' ).length ) {
            console.warn( 'Filter target not found' );
            return false;
        }

        var portnumber = '';

        if (window.location.port.length) {
            portnumber = ":" + window.location.port;
        }

        var $button       = $( e.target ),
            sort_order    = $button.val(),
            template      = $button.data( 'filter-menu-sort-select' ),
            url           = window.location.protocol + "//" + window.location.hostname + portnumber + window.location.pathname,
            $loading_icon = $( '[data-filter-menu-loading-icon]' );

        if ( $loading_icon.length ) {
            $loading_icon.addClass( "show-icon" );
        }

        if( url.length && sort_order.length ) {
            url = url + ( url.indexOf( "?" ) > 0 ? "&" : "?" ) + "sort=" + sort_order;
            history.replaceState( { 'sort_order' : sort_order }, null, url );
        }

        $.ajax( {
            url      : themevars.ajaxurl,
            data     : {
                action   : 'pm_filter_list',
                template : template,
                post_id  : themevars.post_id,
                sort     : sort_order
            },
            type     : 'POST',
            dataType : 'json'
        } ).done( function ( result ) {

            $loading_icon.removeClass( "show-icon" );

            var $target = $('[data-filter-target]');
            $target.empty();

            // update load more button
            if( undefined !== result.data.load_more_button ) {
                if( $( 'a[data-load-more]' ).length ) {
                    $( '[data-load-more-container]' ).html( result.data.load_more_button );
                } else {
                    $( '[data-load-more-container]' ).append( result.data.load_more_button );
                }
            } else {
                $( '[data-load-more-container]' ).html( "" );
            }

            if (  true !== result.success || undefined === result.data.posts ) {
                $target.append( '<div class="text-align-center no-results-message">Geen resultaten</div>' );
                return;
            }

            $target.append( result.data.posts );

            $( document ).trigger( "wpgu-set-favorites-selected" );

            if( window.googletag && googletag.pubadsReady ) {
                googletag.pubads().refresh();
            }
        });
    });

} )( jQuery );
